module.exports = __webpack_public_path__ + "static/media/coinmarketcap.8fc2bd84.svg";